import { c as _c } from "react/compiler-runtime";
import { TourFilterRoomTimeRow } from "@website/accommodation-ui/tour-result-header/tour-filter-room-time/tour-filter-room-time-row";
import { useRouter } from "next/router";
interface Properties {
  cityName: string;
}
export function TourFilterRoomTime(t0) {
  const $ = _c(23);
  const {
    cityName
  } = t0;
  const {
    query,
    pathname,
    replace
  } = useRouter();
  const {
    preferredDepartureTimes,
    preferredReturnTimes
  } = query as Record<string, string>;
  let t1;
  if ($[0] !== preferredDepartureTimes) {
    t1 = preferredDepartureTimes ? decodeURIComponent(preferredDepartureTimes).split(",") : [];
    $[0] = preferredDepartureTimes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const preferredDepartureTimesArray = t1;
  let t2;
  if ($[2] !== preferredReturnTimes) {
    t2 = preferredReturnTimes ? decodeURIComponent(preferredReturnTimes).split(",") : [];
    $[2] = preferredReturnTimes;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const preferredReturnTimesArray = t2;
  let t3;
  if ($[4] !== pathname || $[5] !== query || $[6] !== replace) {
    t3 = function onChange(t4) {
      const {
        isDeparture
      } = t4;
      return function (values) {
        const key = isDeparture ? "preferredDepartureTimes" : "preferredReturnTimes";
        const newQuery = {
          ...query
        };
        if (values.length > 0) {
          newQuery[key] = values.join(",");
        } else {
          delete newQuery[key];
        }
        replace({
          pathname,
          query: newQuery
        }, undefined, {
          shallow: true,
          scroll: false
        });
      };
    };
    $[4] = pathname;
    $[5] = query;
    $[6] = replace;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onChange = t3;
  const t4 = `رسیدن به ${cityName}`;
  let t5;
  if ($[8] !== onChange) {
    t5 = onChange({
      isDeparture: true
    });
    $[8] = onChange;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== preferredDepartureTimesArray || $[11] !== t4 || $[12] !== t5) {
    t6 = <TourFilterRoomTimeRow title={t4} desc={"\u0642\u0628\u0644 \u0627\u0632 \u062A\u062D\u0648\u06CC\u0644 \u0647\u062A\u0644 (\u06F1\u06F4:\u06F0\u06F0) \u0628\u0647 \u0645\u0642\u0635\u062F \u0628\u0631\u0633\u0645"} selectedValues={preferredDepartureTimesArray} switchValue="00:00-14:00" onChange={t5} />;
    $[10] = preferredDepartureTimesArray;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `حرکت از ${cityName}`;
  let t8;
  if ($[14] !== onChange) {
    t8 = onChange({
      isDeparture: false
    });
    $[14] = onChange;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== preferredReturnTimesArray || $[17] !== t7 || $[18] !== t8) {
    t9 = <TourFilterRoomTimeRow title={t7} desc={"\u0632\u0645\u0627\u0646 \u0628\u0631\u06AF\u0634\u062A \u0628\u0639\u062F \u0627\u0632 \u062E\u0631\u0648\u062C \u0627\u0632 \u0647\u062A\u0644 (\u06F1\u06F2:\u06F0\u06F0) \u0628\u0627\u0634\u062F"} selectedValues={preferredReturnTimesArray} switchValue="12:00-00:00" onChange={t8} />;
    $[16] = preferredReturnTimesArray;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t9) {
    t10 = <>{t6}{t9}</>;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}